import { getMessagesApiUrl } from "@/shared/config";
import { authService } from "@/features/auth/services/authService";
import type { MessagesResponse } from "../types";

const DEFAULT_LIMIT = 50;

export async function fetchMessages(
  chatId: string,
  cursor?: string,
  limit = DEFAULT_LIMIT
): Promise<MessagesResponse> {
  const token = await authService.getAccessToken();

  const url = new URL(getMessagesApiUrl());
  url.searchParams.set("chatId", chatId);
  if (cursor) {
    url.searchParams.set("cursor", cursor);
  }
  url.searchParams.set("limit", String(limit));

  const response = await fetch(url.toString(), {
    method: "GET",
    credentials: "include",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch messages: ${response.status}`);
  }

  return response.json();
}
